/* eslint-disable eqeqeq */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable no-redeclare */
/* eslint-disable react/no-direct-mutation-state */
/* eslint-disable no-use-before-define */

import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { Link } from 'react-router-dom';
// import { Card, Col, Container, Figure, Modal, Row, Table, OverlayTrigger, Form, Popover, Tab, Tabs, Pagination,Button, Toast } from 'react-bootstrap';

import { Col, Container, Figure, Row } from 'react-bootstrap';

let menuKey = 'mk';
class Sidebar extends React.Component {

    constructor(props) {
        super();
        this.state = {
            menuActiveIndex: parseInt(sessionStorage.getItem('mk')) ? parseInt(sessionStorage.getItem('mk')) : 0
        };
        this.toggleBox = this.toggleBox.bind(this);
        this.toggleMenu = this.toggleMenu.bind(this);

        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    toggleBox(index) {
        this.setState({ menuActiveIndex: index });
        sessionStorage[menuKey] = index;
        this.toggleMenu();
    }

    toggleMenu() {
        this.props.toggleMenu(false);
    }

    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
            this.props.toggleMenu(false);
        }
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    render() {
        const active = this.state.menuActiveIndex;
        const cur_loc = this.props.cur_loc;
        return (
            <Container fluid ref={this.wrapperRef} className={this.props.mobile_menu_toggle ? 'Sidebar active' : 'Sidebar'}>
                <Row>
                    <Col className="p-0">
                        <Figure className="m-0 bg-light">
                            <Figure.Image
                                alt="Deposit"
                                src="./images/Deposit.png"
                                className="w-100"
                            />
                        </Figure>
                    </Col>
                </Row>
                <Row>
                    <Col className="p-0">
                        <ul className="p-0">
                            <li className={active == 0 ? 'active' : ''} onClick={() => this.toggleBox(0)}><Link to="/">Dashboard</Link></li>
                            <li className={active == 1 ? 'active' : ''} onClick={() => this.toggleBox(1)}><Link to="/isnrequest">International Standard Number</Link></li>
                            <li className={active == 2 ? 'active' : ''} onClick={() => this.toggleBox(2)}>
                                <Link to="/depositrequest">Deposit</Link>
                            </li>
                            <li className={active == 3 ? 'active' : ''} onClick={() => this.toggleBox(3)}><Link to="/ciprequest">Cataloguing in Publication </Link></li>
                            <li className={active == 5 ? 'active' : ''} onClick={() => this.toggleBox(5)}><Link to="/setting">Publisher Account Information</Link></li>
                            <li className={active == 6 ? 'active' : ''} onClick={() => this.toggleBox(6)}><Link to="/report">Report</Link></li>

                        </ul>
                    </Col>
                </Row>
            </Container>
        );
    }
}


export default Sidebar;

